/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  POST_ACESDBS_FILES,
  GET_ACESDBS_FILES_BY_FILE_ID,
  DELETE_ACESDBS_FILES_BY_FILE_ID,
} from './actionTypes';

/**
 * Updates the details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const postAcesdbsFilesReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, POST_ACESDBS_FILES);

/**
 * Updates the indicator of creation of details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingPostAcesdbsFilesReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, POST_ACESDBS_FILES);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const postAcesdbsFilesErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, POST_ACESDBS_FILES);

/**
 * Updates the details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const getAcesdbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, GET_ACESDBS_FILES_BY_FILE_ID);

/**
 * Updates the indicator of creation of details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingGetAcesdbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, GET_ACESDBS_FILES_BY_FILE_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const getAcesdbsFilesByFileIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, GET_ACESDBS_FILES_BY_FILE_ID);

/**
 * Updates the details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const deleteAcesdbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, DELETE_ACESDBS_FILES_BY_FILE_ID);

/**
 * Updates the indicator of creation of details in the 'ACESDocumentService' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingDeleteAcesdbsFilesByFileIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, DELETE_ACESDBS_FILES_BY_FILE_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const deleteAcesdbsFilesByFileIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, DELETE_ACESDBS_FILES_BY_FILE_ID);

const reducers = combineReducers({
  postAcesdbsFiles: postAcesdbsFilesReducer,

  isFetchingPostAcesdbsFiles: isFetchingPostAcesdbsFilesReducer,
  postAcesdbsFilesError: postAcesdbsFilesErrorReducer,

  getAcesdbsFilesByFileId: getAcesdbsFilesByFileIdReducer,

  isFetchingGetAcesdbsFilesByFileId: isFetchingGetAcesdbsFilesByFileIdReducer,
  getAcesdbsFilesByFileIdError: getAcesdbsFilesByFileIdErrorReducer,

  deleteAcesdbsFilesByFileId: deleteAcesdbsFilesByFileIdReducer,

  isFetchingDeleteAcesdbsFilesByFileId: isFetchingDeleteAcesdbsFilesByFileIdReducer,
  deleteAcesdbsFilesByFileIdError: deleteAcesdbsFilesByFileIdErrorReducer,
});

export default { reducers };
